// Dashboard/Widget Constants & Types.

// Constants.
export const CHART_HEIGHT = 360 as const;
export const CHART_WIDTH = '100%' as const;
export const CHART_MARGIN_TOP_DESK = 50 as const; // keeps legend out of chart boundary.
export const CHART_MARGIN_TOP_MOBI = 8 as const;
export const STALE_TIME = 300000 as const; // 5 minutes.
export const DOMAIN_FIELD_NAME = 'hostname' as const;
export const DOMAIN_RESOLVER_NAME = 'domainfilter' as const;

// Types.
export type TBloxAxisConfigMultiple = {
  label: string;
  fields: string[];
};

export type TBloxAxisConfig = TBloxAxisConfigMultiple | string[];

export type TCurrentSeries = {
  type: string; // 'integer' | 'string' | 'date';
  label: string;
  format?: 'currency' | 'number' | 'percentage' | 'date' | undefined;
  currency?: string; // 'USD';
  date_format?: string; // 'm';
};

export const defaultDateRangeFilter = {
  type: 'group',
  name: 'dateRangeFilter',
  label: 'Date Range',
  required: false,
  sensitive: false,
  help: null,
  tooltip: null,
  icon: null,
  default: null,
  config: {
    children: [
      {
        type: 'datetime',
        name: 'startDate',
        label: 'Start Date',
        required: false,
        sensitive: false,
        help: null,
        tooltip: null,
        icon: null,
        default: 'today -30 days',
        config: {
          relative: true,
          step: 'day',
          resolution: 'date',
        },
        access: {
          readonly: false,
        },
      },
      {
        type: 'datetime',
        name: 'endDate',
        label: 'End Date',
        required: false,
        sensitive: false,
        help: null,
        tooltip: null,
        icon: null,
        default: 'yesterday',
        config: {
          relative: true,
          step: 'day',
          resolution: 'date',
        },
        access: {
          readonly: false,
        },
      },
    ],
    collapsed: false,
  },
  access: {},
};
